module.exports = __webpack_public_path__ + "assets/img/activity-time-2ef7eeef.png";